<template>
  <div class="app">
    <notifications></notifications>
    <section class="section">
      <div class="columns">
        <div class="column">
          <div :key="$route.fullPath">
            <header-page></header-page>
            <slot></slot>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import HeaderPage from '@/components/HeaderPage'

export default {
  name: 'app',
  components: {
    HeaderPage
  }
}
</script>
